import {createActions} from 'redux-actions';

export const {getMyProfile, getMyProfileSuccess, getMyProfileFailure} = createActions({
    GET_MY_PROFILE: () => {},
    GET_MY_PROFILE_SUCCESS: (payload: any) => payload,
    GET_MY_PROFILE_FAILURE: () => {},
});
